<template>
  <div class="login-page" style="overflow-x:hidden ">
    <div style="margin-top: 5vw;margin-right: 15vw;display: flex;flex-direction: column;align-items:center;width: 30vw;">
      <div class="large-title">山西专版</div>
      <div class="card-title">理化生实验操作考试训练平台</div>
      <div class="login-card">
        <el-form
          ref="form"
          class="form"
          :model="form"
          label-width="0px">
          <el-form-item  prop="account"  style="margin-bottom: 1.5vw">
            <el-input placeholder="请输入账号"  style="font-size: 1vw;display: flex;align-items: center" v-model="form.account" id="account">
              <i class="code-icon icon-user" slot="prefix" ></i>
            </el-input>
          </el-form-item>
          <el-form-item  prop="password" style="margin-bottom: 1vw">
            <el-input placeholder="请输入密码"  id="password"  style="font-size: 1vw"  ref="pwd" v-model="form.password" :type="showPwd?'text':'password'">
              <i class="code-icon icon-password" slot="prefix"  ></i>
              <i class="el-icon-view" style="font-size: 1.2vw;margin-right: 0.5vw;cursor: pointer;margin-top: 0.5vw" slot="suffix" @click="showPwd=!showPwd"></i>
            </el-input>
            <div style="width: 80%;height: 1.5vw;margin-left: 1vw;margin-top: 0.5vw;font-size: 0.7vw;line-height: 1.5vw;color: red" >
              {{ errmsg }}
            </div>
          </el-form-item>
          <el-form-item>
            <div class="login-btn" @click="login" id="login">立即登录</div>
          </el-form-item>
        </el-form>


      </div>

    </div>
    <div class="icon"></div>
  </div>
</template>

<script>


import loginCard from '@/components/loginCard'
import NavHeader from '@/components/NavHeader'
import loginCard_desktop from "@/components/loginCard_desktop";
import {getHistory} from "@/api/app";
import {setHeartBeatToken, setShanxiToken} from "@/utils/auth";
import {checkStatus} from "@/api/user";
export default {
  name: 'login',
  components:{
    NavHeader,
    loginCard_desktop
  },
  layout:'home',
  data(){
    return{
      showPwd:false,
      loginURL:'https://api.xiyilab.com/v1/auth/login',
      errmsg:'',
      hb_string:'',
      form:{
        account:'',
        password:''
      }
    }
  },
  created() {
      window.addEventListener('keydown',function (e){
        if(e.keyCode==13){
          document.getElementById('login').click()
        }
      })
  },
  watch:{
    errmsg:function (){
      setTimeout(()=>{
        this.errmsg=''
      },3000)
    }
  },
  mounted() {
    console.log(navigator.userAgent.toLowerCase())
    const isDesktop = navigator.userAgent.toLowerCase().indexOf('electron')==-1?'false':'true'
    this.hb_string=isDesktop.toString()
  },
  methods:{
    login(){
      this.$axios.post(this.loginURL,this.form).then(res=>{
        if(res.data.status==='ok'){
          console.log(res.data.data)
          if(res.data.data['user'].groups.find(item=>item.id==7)){
            setShanxiToken(res.data.data['auth'].token)
            let client=this.hb_string=='true'?'desktop':'web'
            checkStatus({client:client,signature:res.data['signature']}).then(r=>{
              console.log(r)
              if(r.status=='ok'){
                debugger
                this.hb_string+='-'+res.data.data['signature']+'-'+res.data.data['hb_interval']
                setHeartBeatToken(this.hb_string)
                this.$router.push('/custom/shanxi/app-list')
              }
              else{
                console.log(123)
                this.$message.error('当前账号已经登陆')
              }
            })

          }
          else{
            this.$message.warning('请检查账号，当前账号无法使用本产品')
          }
        }
        else{
          this.errmsg=res.data.message
        }
      })
    }
  }
}
</script>

<style scoped>
*{
  cursor: default;
}
.el-input--medium, /deep/  .el-input__prefix{
  height: 2vw;
}
.el-input--medium, /deep/ .el-input__inner {
  border-radius: 2vw;
  height: 2vw;
  position: relative;
  text-indent: 0.8vw;
}
.el-input--medium, /deep/ .el-input__inner::-webkit-input-placeholder{
  line-height: 2vw;
  font-size: 0.9vw;
}

.el-input--medium, /deep/ .el-input__inner::-ms-reveal{display:none;}
.login-page{
  width: 100vw;
  height: 100vh;
  background-image: url("http://data.xiyilab.com/web/main/static/login/图层6.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover ;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
.login-card{
  width: 23vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-title{
  margin-top: 0vw;

  height: 4vw;
  width: 30vw;
  line-height: 4vw;
  font-size: 2vw;
  font-family: test;
  font-weight: 400;
  text-align: center;
  color: rgb(52, 124, 239);
}
.large-title{
  margin-top: 0vw;

  font-weight: 600;
  height: 4vw;
  line-height: 4vw;
  font-size: 2vw;
  font-family: test;
  text-align: center;
  color: rgb(52, 124, 239);
}
.form{
  margin-top: 2vw;
  width: 80%;

}
.code-icon{
  display: block;
  margin-top: 0.5vw;
  margin-left: 0.5vw;
  width: 1vw;
  height: 1vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.icon-password{
  background-image: url("http://data.xiyilab.com/web/main/static/login/密码icon.png");
}
.icon-user{
  background-image: url("http://data.xiyilab.com/web/main/static/login/用户icon.png");
}
.login-btn{
  width: 100%;
  height: 2vw;
  background-image: linear-gradient(90deg, #3f34db 0%, #5280f9 100%);
  color: white;
  font-weight: 600;
  letter-spacing: 1rem;
  border-radius: 3vw;
  font-size: 1.1vw;
  font-family: test;
  cursor: pointer;
  text-align: center;
  line-height: 2vw;
  padding: 0px;
  margin-top: 1vw;
  margin-bottom: 2vw;
}
.icon{
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  width: 8vw;
  height: 4vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 4vw;
  margin-right: 12vw;

}

</style>
